import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/certification-demo.png'
import _imports_1 from '@/assets/images/certification-tag.png'


_pushScopeId("data-v-16fd2468")
const _hoisted_1 = {
  key: 0,
  class: "custom-dialog-overlay"
}
const _hoisted_2 = { class: "custom-dialog-header" }
const _hoisted_3 = { class: "custom-dialog-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-close" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "custom-dialog-body" }
const _hoisted_7 = { class: "dialog-notice" }
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = { class: "label-with-required" }
const _hoisted_10 = { class: "label-left" }
const _hoisted_11 = { class: "required" }
const _hoisted_12 = { class: "form-item" }
const _hoisted_13 = { class: "label-with-required" }
const _hoisted_14 = { class: "label-left" }
const _hoisted_15 = { class: "required" }
const _hoisted_16 = { class: "upload-wrapper" }
const _hoisted_17 = {
  key: 0,
  class: "upload-loading-container"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "image-actions" }
const _hoisted_20 = {
  key: 2,
  class: "upload-content"
}
const _hoisted_21 = { class: "upload-left" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-circle-plus upload-icon" }, null, -1)
const _hoisted_23 = { class: "upload-text" }
const _hoisted_24 = { class: "upload-tip" }
const _hoisted_25 = { class: "upload-tip" }
const _hoisted_26 = { class: "upload-right" }
const _hoisted_27 = { class: "example-image-wrapper" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "certification-tag",
  alt: "角标"
}, null, -1)
const _hoisted_29 = { class: "form-item" }
const _hoisted_30 = { class: "label-left" }
const _hoisted_31 = {
  key: 0,
  class: "required"
}
const _hoisted_32 = {
  key: 1,
  class: "optional"
}
const _hoisted_33 = { class: "upload-wrapper" }
const _hoisted_34 = {
  key: 0,
  class: "upload-loading-container"
}
const _hoisted_35 = { class: "file-info" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-document file-icon" }, null, -1)
const _hoisted_37 = { class: "file-name" }
const _hoisted_38 = { class: "file-actions" }
const _hoisted_39 = {
  key: 2,
  class: "upload-content"
}
const _hoisted_40 = { class: "upload-left" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-circle-plus upload-icon" }, null, -1)
const _hoisted_42 = { class: "upload-text" }
const _hoisted_43 = { class: "upload-tip" }
const _hoisted_44 = { class: "upload-right" }
const _hoisted_45 = { class: "example-image-wrapper" }
const _hoisted_46 = ["src"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "certification-tag",
  alt: "角标"
}, null, -1)
const _hoisted_48 = { class: "custom-dialog-footer" }
const _hoisted_49 = { class: "dialog-deadline" }
const _hoisted_50 = { class: "preview-image-wrapper" }
const _hoisted_51 = ["src"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-close" }, null, -1)
const _hoisted_53 = [
  _hoisted_52
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "custom-dialog",
          onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.lang('certification.dialog.title')), 1),
            _createElementVNode("button", {
              class: "custom-dialog-close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleOnlyClose()))
            }, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.lang('certification.dialog.notice')), 1),
            _createVNode(_component_el_form, {
              ref: "formRef",
              model: _ctx.form,
              rules: _ctx.rules
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.lang('certification.form.corpName')), 1),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.lang('certification.form.corpName.required')), 1)
                    ])
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.corpName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.corpName = $event)),
                    placeholder: _ctx.lang('certification.form.corpName.placeholder'),
                    class: "form-input"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.lang('certification.form.businessLicense')), 1),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.lang('certification.form.businessLicense.required')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_el_upload, {
                      ref: "businessLicenseUpload",
                      accept: ".jpg,.png",
                      "file-list": _ctx.businessLicenseFileList,
                      "show-file-list": false,
                      action: "",
                      limit: 1,
                      "on-exceed": _ctx.handleBusinessLicenseExceed,
                      "http-request": _ctx.handleBusinessLicenseUpload,
                      "on-remove": _ctx.handleBusinessLicenseRemove,
                      "before-upload": _ctx.beforeBusinessLicenseUpload,
                      disabled: !!_ctx.form.businessLicenseUrl,
                      drag: "",
                      class: "upload-dragger"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.businessLicenseUploading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_el_icon, { class: "is-loading" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Loading)
                                ]),
                                _: 1
                              })
                            ]))
                          : (_ctx.form.businessLicenseUrl)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "uploaded-image-container",
                                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.form.businessLicenseUrl,
                                  class: "uploaded-image",
                                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handlePreview(_ctx.form.businessLicenseUrl)), ["stop"]))
                                }, null, 8, _hoisted_18),
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("i", {
                                    class: "el-icon-zoom-in preview-icon",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handlePreview(_ctx.form.businessLicenseUrl)), ["stop"]))
                                  }),
                                  _createElementVNode("i", {
                                    class: "el-icon-delete delete-icon",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleBusinessLicenseRemove && _ctx.handleBusinessLicenseRemove(...args)), ["stop"]))
                                  })
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _hoisted_22,
                                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.lang('certification.form.businessLicense.upload')), 1),
                                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.lang('certification.form.businessLicense.tip')), 1),
                                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.lang('certification.form.businessLicense.tip2')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("img", {
                                      src: _imports_0,
                                      class: "example-image",
                                      alt: "示例图片",
                                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (
                          _ctx.handlePreviewExample(require('@/assets/images/certification-origin1.png'))
                        ), ["stop"]))
                                    }),
                                    _hoisted_28
                                  ])
                                ])
                              ]))
                      ]),
                      _: 1
                    }, 8, ["file-list", "on-exceed", "http-request", "on-remove", "before-upload", "disabled"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.authorizationRequired ? 'label-with-required' : 'label-with-optional')
                  }, [
                    _createElementVNode("div", _hoisted_30, [
                      _createTextVNode(_toDisplayString(_ctx.lang('certification.form.authorLetter')) + " ", 1),
                      (_ctx.authorizationRequired)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.lang('certification.form.authorLetter.required')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.lang('certification.form.authorLetter.optional')), 1))
                    ]),
                    _createElementVNode("a", {
                      href: "#",
                      class: "download-link",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDownloadTemplate && _ctx.handleDownloadTemplate(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.lang('certification.form.authorLetter.download')), 1)
                  ], 2),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_el_upload, {
                      ref: "authorLetterUpload",
                      accept: ".doc,.docx,.pdf",
                      "file-list": _ctx.authorLetterFileList,
                      "show-file-list": false,
                      action: "",
                      limit: 1,
                      "on-exceed": _ctx.handleAuthorLetterExceed,
                      "http-request": _ctx.handleAuthorLetterUpload,
                      "on-remove": _ctx.handleAuthorLetterRemove,
                      "before-upload": _ctx.beforeAuthorLetterUpload,
                      disabled: !!_ctx.form.authorLetterUrl,
                      drag: "",
                      class: "upload-dragger"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.authorLetterUploading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _createVNode(_component_el_icon, { class: "is-loading" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Loading)
                                ]),
                                _: 1
                              })
                            ]))
                          : (_ctx.form.authorLetterUrl)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "uploaded-file-container",
                                onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createElementVNode("div", _hoisted_35, [
                                  _hoisted_36,
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.authorLetterFileList[0]?.name || _ctx.getFileName(_ctx.form.authorLetterUrl)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("i", {
                                    class: "el-icon-delete delete-icon",
                                    onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleAuthorLetterRemove && _ctx.handleAuthorLetterRemove(...args)), ["stop"]))
                                  })
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _hoisted_41,
                                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.lang('certification.form.authorLetter.upload')), 1),
                                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.lang('certification.form.authorLetter.tip')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("img", {
                                      src: _ctx.getExampleImageUrl(),
                                      class: "example-image",
                                      alt: "示例图片",
                                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.handlePreviewExample(_ctx.getAuthorLetterPreviewUrl())), ["stop"]))
                                    }, null, 8, _hoisted_46),
                                    _hoisted_47
                                  ])
                                ])
                              ]))
                      ]),
                      _: 1
                    }, 8, ["file-list", "on-exceed", "http-request", "on-remove", "before-upload", "disabled"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _createElementVNode("div", _hoisted_48, [
            (!_ctx.forceCorpAuth)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: _ctx.handleClose,
                  class: "cancel-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.lang('certification.form.cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleSubmit,
              loading: _ctx.submitLoading,
              class: "submit-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.lang('certification.form.submit')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.lang('certification.dialog.deadline')), 1)
        ]),
        (_ctx.previewDialogVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "preview-dialog-overlay",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.previewDialogVisible = false))
            }, [
              _createElementVNode("div", {
                class: "preview-dialog-container",
                onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("img", {
                    src: _ctx.previewImageUrl,
                    class: "preview-image",
                    alt: "预览图片"
                  }, null, 8, _hoisted_51),
                  _createElementVNode("button", {
                    class: "preview-close-button",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.previewDialogVisible = false))
                  }, _hoisted_53)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}